import { Injectable } from '@angular/core';
import { ApiService, ApiServiceContext } from '@app/services/api.service';
import { MgtfeForm } from '@app/models/form/mgtfe-form.model';
import { Observable } from 'rxjs';
import 'rxjs-compat/add/observable/of';
import {catchError, map} from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class MgtfeFormService extends ApiService{

  constructor(ctx: ApiServiceContext){
    super(ctx);
  }

  save(mgtfeForm:MgtfeForm) : Observable<MgtfeForm>{
    return mgtfeForm.id ?
      this.http.put<MgtfeForm>('/api/graduation-work-requests', mgtfeForm).pipe(catchError(this.handleError)):
      this.http.post<MgtfeForm>('/api/graduation-work-requests', mgtfeForm).pipe(catchError(this.handleError));
  }

  submit(mgtfeForm:MgtfeForm) : Observable<MgtfeForm>{
    return this.http.post<MgtfeForm>('/api/graduation-work-requests/submit', mgtfeForm).pipe(catchError(this.handleError));
  }

  get(id: number) : Observable<MgtfeForm>{
    return this.http.get<MgtfeForm>(`/api/graduation-work-requests/${id}`).pipe(catchError(this.handleError));
  }

  searchForUser(idUser:number, criteria?: any) : Observable<MgtfeForm[]>{
    let params = new HttpParams();
    if (criteria) {
      criteria.treated = (criteria.treated != true && criteria.treated != false) ? 'any' : criteria.treated;

      Object.entries(criteria)
        .map(([attribute, value]) => [attribute, value != null && value != undefined ? `${value}` : value])
        .filter(([attribute, value]) => !!value)
        .forEach(([attribute, value]) => params = params.set(`${attribute}`, `${value}`));
    }
    return this.http.get<MgtfeForm[]>(`/api/user/graduation-work-requests`, { params }).pipe(
      map(mgtfes => mgtfes.map(mgtfe => this.setPdfUrl(mgtfe))),
      catchError(this.handleError)
    );
  }

  getPdfUrl(mgtfe: MgtfeForm): string {
    return `./api/graduation-work-requests/${mgtfe.id}/report`;
  }

  private setPdfUrl(mgtfe: MgtfeForm): MgtfeForm {
    if (mgtfe.hasPdf) {
      mgtfe.pdfUrl = this.getPdfUrl(mgtfe);
    }
    return mgtfe;
  }

}
